import type { StoreMapping, StoreProduct } from "./api";

export interface ConversionDefaults {
  conversionMode: StoreMapping["conversionMode"];
  packageAmount: string;
  packageUnit: string;
  unitsPerSku: string;
}

/** Compras units that are one store product each: a bottle or a can is bought as a bottle or a can. */
const CONTAINER_UNITS = new Set(["botella", "lata"]);

/**
 * The conversion the store picker proposes for linking `product` to a Compras
 * line counted in `item.unit` (empty for a line in grams). The person can
 * edit it before saving.
 */
export function defaultConversionFor(product: StoreProduct, item: { unit: string }): ConversionDefaults {
  // "2 botellas" of a "Pozima 330 ml" product: 2 products. Sizing by ml
  // would find no grams to divide and always add 1.
  if (CONTAINER_UNITS.has(item.unit) && product.packageUnit !== "un") {
    return { conversionMode: "grouped-units", packageAmount: "", packageUnit: "", unitsPerSku: "1" };
  }
  if (product.packageAmount && product.packageUnit && product.packageUnit !== "un") {
    return {
      conversionMode: "measurable",
      packageAmount: String(product.packageAmount),
      packageUnit: product.packageUnit,
      unitsPerSku: "1",
    };
  }
  if (product.measurementUnit && product.measurementUnit !== "un" && product.unitMultiplier > 0) {
    return {
      conversionMode: "measurable",
      packageAmount: String(product.unitMultiplier),
      packageUnit: product.measurementUnit,
      unitsPerSku: "1",
    };
  }
  if (product.packageAmount && product.packageUnit === "un") {
    return {
      conversionMode: "grouped-units",
      packageAmount: "",
      packageUnit: "",
      unitsPerSku: String(product.packageAmount),
    };
  }
  return {
    conversionMode: "grouped-units",
    packageAmount: "",
    packageUnit: "",
    unitsPerSku: "1",
  };
}
